import { ChevronRight } from 'lucide-react'

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'

/** AI-generated summary of coverage — collapsed by default. */
export function PolicyCoverageSummary({ summary }: { summary: string }) {
  return (
    <Collapsible className="group/summary">
      <CollapsibleTrigger className="text-md text-muted-foreground flex cursor-pointer items-center gap-1 font-semibold">
        <ChevronRight className="h-4 w-4 transition-transform duration-200 group-data-[state=open]/summary:rotate-90" />
        Summary of coverage
      </CollapsibleTrigger>
      <CollapsibleContent>
        <p className="text-md mt-2 max-w-3xl font-medium whitespace-pre-line text-black">{summary}</p>
      </CollapsibleContent>
    </Collapsible>
  )
}
